import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ListChecks, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";

// Listes d'une personne : ajout / retrait dans les listes autorisées (relation Persona « Listes Annuaire »)
export function PersonLists({ person }) {
  const queryClient = useQueryClient();
  const [choice, setChoice] = useState("");
  const lists = useQuery({ queryKey: ["lists", "editable"], queryFn: async () => (await api.get("/lists?status=active&page_size=100")).data.items });
  const mine = person.lists || [];
  const available = (lists.data || []).filter((l) => l.can_edit && !mine.some((m) => m.id === l.id));
  const change = async (listId, action) => {
    try {
      await api.post(`/lists/${listId}/members`, { person_ids: [person.id], action });
      toast.success(action === "add" ? "Ajouté(e) à la liste" : "Retiré(e) de la liste");
      setChoice("");
      ["person", "lists", "list"].forEach((k) => queryClient.invalidateQueries({ queryKey: [k] }));
    } catch (err) {
      toast.error(errorMessage(err));
    }
  };
  return (
    <div data-testid="person-lists">
      <div className="flex flex-wrap gap-2">
        {!mine.length && <span className="text-sm text-muted-foreground">Dans aucune liste.</span>}
        {mine.map((l) => (
          <span key={l.id} className="inline-flex items-center gap-1 rounded-full bg-stone-100 py-1 pl-2.5 pr-1 text-xs font-semibold text-stone-700">
            <Link to={`/listes/${l.id}`} className="inline-flex items-center gap-1 hover:underline"><ListChecks className="h-3 w-3" /> {l.name}</Link>
            {!l.archived && <button type="button" onClick={() => change(l.id, "remove")} className="rounded-full p-0.5 hover:bg-stone-200" data-testid={`person-list-remove-${l.id}`} aria-label="Retirer"><X className="h-3 w-3" /></button>}
          </span>
        ))}
      </div>
      {available.length > 0 && (
        <div className="mt-3 flex gap-2">
          <select value={choice} onChange={(e) => setChoice(e.target.value)} className="h-9 min-w-0 flex-1 rounded-full border border-input bg-white px-3 text-sm" data-testid="person-list-select">
            <option value="">Ajouter à une liste…</option>
            {available.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
          </select>
          <Button size="sm" className="rounded-full" disabled={!choice} onClick={() => change(choice, "add")} data-testid="person-list-add-button"><Plus className="h-4 w-4" /></Button>
        </div>
      )}
    </div>
  );
}
